module.exports = {"pathContext":{"name":"ChangelogConnection","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"edges","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"ChangelogEdge","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"pageInfo","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"PageInfo","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-changelog-connection.json
// module id = 1699
// module chunks = 62133431115338